import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-82bdba28")

_pushScopeId("data-v-82bdba28")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "privacy businessSection" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "privacy businessBlock" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "titleBlock" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "contentBlock" }
const _hoisted_10 = { class: "titleBlock" }
const _hoisted_11 = { class: "contentBlock" }
const _hoisted_12 = { class: "subtitleBlock" }
const _hoisted_13 = { class: "listTempl1" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = { class: "titleBlock" }
const _hoisted_19 = { class: "contentBlock" }
const _hoisted_20 = { class: "listTempl1" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { class: "titleBlock" }
const _hoisted_31 = { class: "contentBlock" }
const _hoisted_32 = { class: "subtitleBlock" }
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = { class: "titleBlock" }
const _hoisted_37 = { class: "contentBlock" }
const _hoisted_38 = { class: "subtitleBlock" }
const _hoisted_39 = { class: "listTempl1" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = { class: "titleBlock" }
const _hoisted_45 = { class: "contentBlock" }
const _hoisted_46 = { class: "subtitleBlock" }
const _hoisted_47 = { class: "listTempl1" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_60 = { class: "titleBlock" }
const _hoisted_61 = { class: "contentBlock" }
const _hoisted_62 = { class: "subtitleBlock" }
const _hoisted_63 = { class: "listTempl1" }
const _hoisted_64 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_65 = { id: "head" }
const _hoisted_66 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_70 = { class: "titleBlock" }
const _hoisted_71 = { class: "contentBlock" }
const _hoisted_72 = { class: "subtitleBlock" }
const _hoisted_73 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = { class: "titleBlock" }
const _hoisted_77 = { class: "contentBlock" }
const _hoisted_78 = { class: "subtitleBlock" }
const _hoisted_79 = { class: "listTempl1" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_81 = { id: "head" }
const _hoisted_82 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_84 = { id: "head" }
const _hoisted_85 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_86 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_87 = { id: "head" }
const _hoisted_88 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_89 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_90 = { id: "head" }
const _hoisted_91 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_93 = { id: "head" }
const _hoisted_94 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_96 = { id: "head" }
const _hoisted_97 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_98 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_99 = { id: "head" }
const _hoisted_100 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_101 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_102 = { id: "head" }
const _hoisted_103 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_104 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_106 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_108 = { class: "titleBlock" }
const _hoisted_109 = { class: "contentBlock" }
const _hoisted_110 = { class: "subtitleBlock" }
const _hoisted_111 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_112 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_113 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_114 = { class: "titleBlock" }
const _hoisted_115 = { class: "contentBlock" }
const _hoisted_116 = { class: "subtitleBlock" }
const _hoisted_117 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_118 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_120 = { class: "titleBlock" }
const _hoisted_121 = { class: "contentBlock" }
const _hoisted_122 = { class: "subtitleBlock" }
const _hoisted_123 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_124 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_126 = { class: "titleBlock" }
const _hoisted_127 = { class: "contentBlock" }
const _hoisted_128 = { class: "subtitleBlock" }
const _hoisted_129 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_130 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_132 = { class: "titleBlock" }
const _hoisted_133 = { class: "contentBlock" }
const _hoisted_134 = { class: "subtitleBlock" }
const _hoisted_135 = { class: "subtitleBlock" }
const _hoisted_136 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_139 = { class: "titleBlock" }
const _hoisted_140 = { class: "contentBlock" }
const _hoisted_141 = { class: "subtitleBlock" }
const _hoisted_142 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_143 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_144 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_145 = { class: "titleBlock" }
const _hoisted_146 = { class: "contentBlock" }
const _hoisted_147 = { class: "subtitleBlock" }
const _hoisted_148 = { class: "listTempl1" }
const _hoisted_149 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_150 = { id: "head" }
const _hoisted_151 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_152 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_153 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_154 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_155 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_156 = /*#__PURE__*/_createVNode("span", { class: "num" }, null, -1)
const _hoisted_157 = { id: "head" }
const _hoisted_158 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_159 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_160 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_161 = {
  class: "subtitleBlock",
  id: "subhead"
}
const _hoisted_162 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_163 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_164 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('privacyPolicy.title')), 1),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t('privacyPolicy.subtitle')), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("h2", _hoisted_10, _toDisplayString(_ctx.t('privacyCollectionofPersonalData.title')), 1),
              _createVNode("div", _hoisted_11, [
                _createVNode("p", _hoisted_12, _toDisplayString(_ctx.t('privacyCollectionofPersonalData.subtitle')), 1),
                _createVNode("ul", _hoisted_13, [
                  _createVNode("li", null, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('privacyCollectionofPersonalData.bulletPoint.text1')), 1)
                  ])
                ])
              ]),
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _createVNode("h2", _hoisted_18, _toDisplayString(_ctx.t('TypesofDataCollected.title')), 1),
              _createVNode("div", _hoisted_19, [
                _createVNode("ul", _hoisted_20, [
                  _createVNode("li", null, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.PersonalData.name')) + " " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.PersonalData.text')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.ContactInformation.name')) + " " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.ContactInformation.text')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.AccountDetails.name')) + " " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.AccountDetails.text')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.ProofOfIdentity.name')) + " " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.ProofOfIdentity.text')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.TransactionAndFinancialInformation.name')) + " " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.TransactionAndFinancialInformation.text')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_26,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.TechnicalData.name')) + " " + _toDisplayString(_ctx.t('TypesofDataCollected.bulletPoint.TechnicalData.text')), 1)
                  ])
                ])
              ]),
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _createVNode("h2", _hoisted_30, _toDisplayString(_ctx.t('Children.title')), 1),
              _createVNode("div", _hoisted_31, [
                _createVNode("p", _hoisted_32, _toDisplayString(_ctx.t('Children.subtitle')), 1)
              ]),
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _createVNode("h2", _hoisted_36, _toDisplayString(_ctx.t('StorageOfData.title')), 1),
              _createVNode("div", _hoisted_37, [
                _createVNode("p", _hoisted_38, _toDisplayString(_ctx.t('StorageOfData.subtitle')), 1),
                _createVNode("ul", _hoisted_39, [
                  _createVNode("li", null, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('StorageOfData.bulletPoint.text1')), 1)
                  ])
                ])
              ]),
              _hoisted_41,
              _hoisted_42,
              _hoisted_43,
              _createVNode("h2", _hoisted_44, _toDisplayString(_ctx.t('UseOfData.title')), 1),
              _createVNode("div", _hoisted_45, [
                _createVNode("p", _hoisted_46, _toDisplayString(_ctx.t('UseOfData.subtitle')), 1),
                _createVNode("ul", _hoisted_47, [
                  _createVNode("li", null, [
                    _hoisted_48,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text1')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_49,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text2')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_50,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text3')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_51,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text4')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_52,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text5')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text6')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_54,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text7')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_55,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text8')), 1)
                  ]),
                  _createVNode("li", null, [
                    _hoisted_56,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('UseOfData.bulletPoint.text9')), 1)
                  ])
                ])
              ]),
              _hoisted_57,
              _hoisted_58,
              _hoisted_59,
              _createVNode("h2", _hoisted_60, _toDisplayString(_ctx.t('DisclosureOfPersonalData.title')), 1),
              _createVNode("div", _hoisted_61, [
                _createVNode("p", _hoisted_62, _toDisplayString(_ctx.t('DisclosureOfPersonalData.subtitle')), 1),
                _createVNode("ul", _hoisted_63, [
                  _createVNode("li", null, [
                    _hoisted_64,
                    _createVNode("b", _hoisted_65, _toDisplayString(_ctx.t('DisclosureOfPersonalData.bulletPoint.title')), 1)
                  ]),
                  _createVNode("p", _hoisted_66, _toDisplayString(_ctx.t('DisclosureOfPersonalData.bulletPoint.subtitle')), 1)
                ])
              ]),
              _hoisted_67,
              _hoisted_68,
              _hoisted_69,
              _createVNode("h2", _hoisted_70, _toDisplayString(_ctx.t('DataRetention.title')), 1),
              _createVNode("div", _hoisted_71, [
                _createVNode("p", _hoisted_72, _toDisplayString(_ctx.t('DataRetention.subtitle')), 1)
              ]),
              _hoisted_73,
              _hoisted_74,
              _hoisted_75,
              _createVNode("h2", _hoisted_76, _toDisplayString(_ctx.t('DataSubjectRights.title')), 1),
              _createVNode("div", _hoisted_77, [
                _createVNode("p", _hoisted_78, _toDisplayString(_ctx.t('DataSubjectRights.subtitle')), 1),
                _createVNode("ul", _hoisted_79, [
                  _createVNode("li", null, [
                    _hoisted_80,
                    _createVNode("b", _hoisted_81, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.WithdrawalOfconsent.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_82, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.WithdrawalOfconsent.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_83,
                    _createVNode("b", _hoisted_84, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.DataAccess.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_85, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.DataAccess.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_86,
                    _createVNode("b", _hoisted_87, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.DataPortability.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_88, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.DataPortability.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_89,
                    _createVNode("b", _hoisted_90, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.Objection.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_91, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.Objection.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_92,
                    _createVNode("b", _hoisted_93, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.DataErasureOrDestruction.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_94, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.DataErasureOrDestruction.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_95,
                    _createVNode("b", _hoisted_96, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.Suspension.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_97, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.Suspension.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_98,
                    _createVNode("b", _hoisted_99, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.Rectification.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_100, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.Rectification.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_101,
                    _createVNode("b", _hoisted_102, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.ComplaintLodging.name')), 1)
                  ]),
                  _createVNode("p", _hoisted_103, _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.ComplaintLodging.text')), 1),
                  _createVNode("li", null, [
                    _hoisted_104,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('DataSubjectRights.bulletPoint.text1')), 1)
                  ])
                ])
              ]),
              _hoisted_105,
              _hoisted_106,
              _hoisted_107,
              _createVNode("h2", _hoisted_108, _toDisplayString(_ctx.t('AdvertisingAndMarketing.title')), 1),
              _createVNode("div", _hoisted_109, [
                _createVNode("p", _hoisted_110, _toDisplayString(_ctx.t('AdvertisingAndMarketing.subtitle')), 1)
              ]),
              _hoisted_111,
              _hoisted_112,
              _hoisted_113,
              _createVNode("h2", _hoisted_114, _toDisplayString(_ctx.t('Cookies.title')), 1),
              _createVNode("div", _hoisted_115, [
                _createVNode("p", _hoisted_116, _toDisplayString(_ctx.t('Cookies.subtitle')), 1)
              ]),
              _hoisted_117,
              _hoisted_118,
              _hoisted_119,
              _createVNode("h2", _hoisted_120, _toDisplayString(_ctx.t('DataSecurity.title')), 1),
              _createVNode("div", _hoisted_121, [
                _createVNode("p", _hoisted_122, _toDisplayString(_ctx.t('DataSecurity.subtitle')), 1)
              ]),
              _hoisted_123,
              _hoisted_124,
              _hoisted_125,
              _createVNode("h2", _hoisted_126, _toDisplayString(_ctx.t('DataBreachNotification.title')), 1),
              _createVNode("div", _hoisted_127, [
                _createVNode("p", _hoisted_128, _toDisplayString(_ctx.t('DataBreachNotification.subtitle')), 1)
              ]),
              _hoisted_129,
              _hoisted_130,
              _hoisted_131,
              _createVNode("h2", _hoisted_132, _toDisplayString(_ctx.t('ChangesToThisPrivacyPolicy.title')), 1),
              _createVNode("div", _hoisted_133, [
                _createVNode("p", _hoisted_134, _toDisplayString(_ctx.t('ChangesToThisPrivacyPolicy.subtitle1')), 1),
                _createVNode("p", _hoisted_135, _toDisplayString(_ctx.t('ChangesToThisPrivacyPolicy.subtitle2')), 1)
              ]),
              _hoisted_136,
              _hoisted_137,
              _hoisted_138,
              _createVNode("h2", _hoisted_139, _toDisplayString(_ctx.t('LinksToOtherSites.title')), 1),
              _createVNode("div", _hoisted_140, [
                _createVNode("p", _hoisted_141, _toDisplayString(_ctx.t('LinksToOtherSites.subtitle')), 1)
              ]),
              _hoisted_142,
              _hoisted_143,
              _hoisted_144,
              _createVNode("h2", _hoisted_145, _toDisplayString(_ctx.t('ContactInformation.title')), 1),
              _createVNode("div", _hoisted_146, [
                _createVNode("p", _hoisted_147, _toDisplayString(_ctx.t('ContactInformation.subtitle')), 1),
                _createVNode("ul", _hoisted_148, [
                  _createVNode("li", null, [
                    _hoisted_149,
                    _createVNode("b", _hoisted_150, _toDisplayString(_ctx.t('ContactInformation.DataController.subtitle')), 1)
                  ]),
                  _createVNode("p", _hoisted_151, _toDisplayString(_ctx.t('ContactInformation.DataController.line1')), 1),
                  _createVNode("p", _hoisted_152, _toDisplayString(_ctx.t('ContactInformation.DataController.line2')), 1),
                  _createVNode("p", _hoisted_153, [
                    _createTextVNode(_toDisplayString(_ctx.t('ContactInformation.email.text')) + " ", 1),
                    _createVNode("b", null, _toDisplayString(_ctx.t('address', {
                        account: _ctx.t('ContactInformation.email.account'),
                        domain: _ctx.t('ContactInformation.email.domain')
                      })), 1)
                  ]),
                  _createVNode("p", _hoisted_154, _toDisplayString(_ctx.t('ContactInformation.DataController.line4')), 1),
                  _createVNode("p", _hoisted_155, _toDisplayString(_ctx.t('ContactInformation.DataController.line5')), 1),
                  _createVNode("li", null, [
                    _hoisted_156,
                    _createVNode("b", _hoisted_157, _toDisplayString(_ctx.t('ContactInformation.DataProtectionOfficer.subtitle')), 1)
                  ]),
                  _createVNode("p", _hoisted_158, _toDisplayString(_ctx.t('ContactInformation.DataProtectionOfficer.line1')), 1),
                  _createVNode("p", _hoisted_159, _toDisplayString(_ctx.t('ContactInformation.DataProtectionOfficer.line2')), 1),
                  _createVNode("p", _hoisted_160, [
                    _createTextVNode(_toDisplayString(_ctx.t('ContactInformation.email.text')) + " ", 1),
                    _createVNode("b", null, _toDisplayString(_ctx.t('address', {
                        account: _ctx.t('ContactInformation.email.account'),
                        domain: _ctx.t('ContactInformation.email.domain')
                      })), 1)
                  ]),
                  _createVNode("p", _hoisted_161, _toDisplayString(_ctx.t('ContactInformation.DataProtectionOfficer.line4')), 1)
                ])
              ]),
              _hoisted_162,
              _hoisted_163,
              _hoisted_164
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})